import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';

// Fallback static data in case API returns empty results
const fallbackProducts = [
  {
    id: 1,
    title: "Evercore Yeast Protein - Cafe Mocha",
    img: "/assets/images/Ourbestselleryeast.png",
    searchQuery: "protein"
  },
  {
    id: 2,
    title: "Evercore Collagen Peptides- Blueberry Glow",
    img: "/assets/images/Ourbestsellercollagen.png",
    searchQuery: "collagen"
  },
];

export default function OurBestSeller() {
  const navigate = useNavigate();
  const [products, setProducts] = useState(fallbackProducts);
  const [loading, setLoading] = useState(false);

const sendPurchaseEvent = async () => {
  const eventId = uuidv4();

  // 1️⃣ Browser Event (Facebook Pixel)
  if (window.fbq) {
    window.fbq(
      'track',
      'Purchase',
      {
        value: 1000,
        currency: 'INR'
      },
      {
        eventID: eventId
      }
    );
  }

  // 2️⃣ Server Event (Django API)
  try {
    await fetch('https://evercorenutrition.com/ev_admin/api/fb-event/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        event_id: eventId,
        value: 1000
      })
    });
  } catch (err) {
    console.error("Server event failed:", err);
  }
};

  // Function to fetch product data from API
  const fetchProductData = async (query) => {
    try {
      const response = await fetch(`https://evercorenutrition.com/ev_admin/api/products/search/?q=${query}`);
      const data = await response.json();
      return data.results || [];
    } catch (error) {
      console.error(`Error fetching ${query}:`, error);
      return [];
    }
  };

  // Load data for both products on component mount
  useEffect(() => {
    const loadProducts = async () => {
      setLoading(true);
      
      const proteinResults = await fetchProductData('protein');
      const collagenResults = await fetchProductData('collagen');
      
      // Update products with real data if available, otherwise keep fallback
      const updatedProducts = [
        {
          id: 1,
          title: proteinResults.length > 0 && proteinResults[0]?.name 
            ? proteinResults[0].name 
            : fallbackProducts[0].title,
          img: proteinResults.length > 0 && proteinResults[0]?.main_image 
            ? (proteinResults[0].main_image.startsWith('http') ? proteinResults[0].main_image : `https://evercorenutrition.com${proteinResults[0].main_image}`)
            : fallbackProducts[0].img,
          searchQuery: 'protein',
          productId: proteinResults.length > 0 ? proteinResults[0].id : null,
          productCount: proteinResults.length,
          products: proteinResults
        },
        {
          id: 2,
          title: collagenResults.length > 0 && collagenResults[0]?.name 
            ? collagenResults[0].name 
            : fallbackProducts[1].title,
          img: collagenResults.length > 0 && collagenResults[0]?.main_image 
            ? (collagenResults[0].main_image.startsWith('http') ? collagenResults[0].main_image : `https://evercorenutrition.com${collagenResults[0].main_image}`)
            : fallbackProducts[1].img,
          searchQuery: 'collagen',
          productId: collagenResults.length > 0 ? collagenResults[0].id : null,
          productCount: collagenResults.length,
          products: collagenResults
        }
      ];
      
      setProducts(updatedProducts);
      setLoading(false);
    };
    
    loadProducts();
  }, []);

  const shareProduct = (product) => {
    const url = window.location.origin + `/product/${product.productId || ''}`;

    if (navigator.share) {
      navigator.share({
        title: product.title,
        text: "Check out this product!",
        url,
      });
    } else {
      navigator.clipboard.writeText(url);
      alert("Product link copied!");
    }
  };

  // Handle product click - navigate to product detail page
  const handleProductClick = (product) => {
    if (product.products && product.products.length > 0) {
      navigate(`/product/${product.products[0].id}`);
    } else {
      navigate(`/shop?category=${product.searchQuery}`);
    }
  };

  // Loading state
  if (loading) {
    return (
      <section className="bestSellerSection">
        <div className="container-fluid-lg">
          <div className="title" style={{ 
  textAlign: 'center', 
  display: 'flex', 
  flexDirection: 'column', 
  alignItems: 'center',
  width: '100%' 
}}>
            <h2>Our Best Seller</h2>
            <span className="title-leaf">
              <svg className="icon-width">
                <use href="../assets/svg/leaf.svg#leaf"></use>
              </svg>
            </span>
            <p>Top Categories Of The Week</p>
          </div>
          <div style={{ textAlign: 'center', padding: '50px' }}>
            <p>Loading best sellers...</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="bestSellerSection">
      <div className="container-fluid-lg">
        <div className="title" style={{ 
  textAlign: 'center', 
  display: 'flex', 
  flexDirection: 'column', 
  alignItems: 'center',
  width: '100%' 
}}>
          <h2>Our Best Seller</h2>
          <span className="title-leaf">
            <svg className="icon-width">
              <use href="../assets/svg/leaf.svg#leaf"></use>
            </svg>
          </span>
          <p>Top Categories Of The Week</p>
        </div>

        <div className="bestSellerGrid">
          {products.map((product) => (
            <div 
              className="productCardNew" 
              key={product.id}
              onClick={() => handleProductClick(product)}
              style={{ cursor: 'pointer' }}
            >
              <div 
                className="productImageWrapper" 
                style={{
                  width: '100%',
                  margin: 0,
                  padding: 0,
                  position: 'relative'
                }}
              >
                <img 
                  src={product.img} 
                  alt={product.title} 
                  style={{
                    width: '100%',
                    height: '300px',
                    objectFit: 'cover',
                    display: 'block',
                    margin: 0,
                    padding: 0
                  }}
                />
                <div 
                  className="productOverlay"
                  onClick={(e) => {
                    e.stopPropagation();
                    shareProduct(product);
                  }}
                >
                  <button>
                    <i className="fa fa-share-alt"></i>
                  </button>
                </div>
              </div>

              <div className="productInfo">
                <h3>{product.title}</h3>
                
                <div className="cartRow">
<button 
  className="ourshopnowbtn"
  onClick={async (e) => {
    e.stopPropagation();

    await sendPurchaseEvent(); // 🔥 trigger event first
    handleProductClick(product); // then navigate
  }}
>
  Shop Now
</button>
                </div>
              </div>
            </div>
          ))}

          <div 
          className="promoBanner"
        >
          <img  
            style={{
              width: 'clamp(280px, 100%, 100%)',  /* ← responsive width */
              height: 'clamp(220px, 50vw, 400px)',
              objectFit: 'cover',
              display: 'block',
              margin: 0,
              padding: 0,
              border: '1px solid rgb(220 220 220)',
              borderRadius: '16px'
            }}
            src="/assets/images/Familyposter.webp"
            alt="Promo Banner"
          />
        </div>
        </div>
      </div>
    </section>
  );
}